export const enumTool = {
    getEnumValueDesc(enumObj){
        let result = {}
        for(let key in enumObj){
            result[enumObj[key].value] = enumObj[key].desc
        }
        return result
    },
    getEnumKeyValue(enumObj){
        let result = {}
        for(let key in enumObj){
            result[key] = enumObj[key].value
        }
        return result
    }
}



// WEBPACK FOOTER //
// ./src/lib/enum-tool.js